<template>
  <fragment>
    <AppBody
      title="Pessoas / Pontos de Venda"
      subtitle="Pontos de Venda / Cadastrar - Editar"
    >
      <v-row>
        <v-col cols="8">
          <RegistrationData />
          <Documents />
          <Comission />
        </v-col>
        <v-col cols="4">
          <Equipments />
          <BankData />
        </v-col>
      </v-row>
      <RegistrationActions
        :loader="$pointOfSale.cadastro.loading"
        :actions="actions"
      />
    </AppBody>
    <ModalVisualizarImagem :image="$pointOfSale.visualizarImagem" />
    <ModalConfirmacao
      :textModal="$pointOfSale.text"
      :funcaoModal="$pointOfSale.funcao"
      @updateTable="$pointOfSale.removeTrigger"
    />
  </fragment>
</template>

<script>
import AppBody from "@/layouts/components/AppBody.vue";
import RegistrationData from "@/components/vendas/pontoDeVenda/RegistrationData.vue";
import Comission from "@/components/vendas/pontoDeVenda/Comission.vue";
import BankData from "@/components/vendas/pontoDeVenda/BankData.vue";
import Documents from "@/components/vendas/pontoDeVenda/Documents.vue";
import Equipments from "@/components/vendas/pontoDeVenda/Equipments.vue";
import RegistrationActions from "@/components/global/RegistrationActions.vue";
import ModalVisualizarImagem from "@/components/global/modal-visualizar-imagem.vue";
import ModalConfirmacao from "@/components/global/modal-confirmacao.vue";
import PDVmixins from "@/mixins/PDV.mixins.js";
export default {
  name: "SalesPointSettings",
  metaInfo: {
    title: "Vendas/Pontos de Venda | Adicionar/Editar | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Vendas/Pontos de Venda | Adicionar/Editar | ElevenTickets",
      },
    ],
  },
  components: {
    AppBody,
    RegistrationData,
    Comission,
    BankData,
    Documents,
    Equipments,
    RegistrationActions,
    ModalVisualizarImagem,
    ModalConfirmacao,
  },
  mixins: [PDVmixins],
  data() {
    return {
      actions: [
        {
          name: "Salvar",
          action: () => this.$pointOfSale.registerValidate(),
        },
        {
          name: "Cancelar",
          action: () => this.cancelAction(),
        },
      ],
      estados: [],
      cidades: [],
    };
  },
  computed: {
    tabs() {
      return [
        { tab: "Dados Cadastrais" },
        { tab: "Comissão" },
        { tab: "Dados Financeiros" },
        { tab: "Documentos" },
        { tab: "Equipamentos" },
      ];
    },
  },
  watch: {
    estados(e) {
      this.$config.getCidades(e.id);
    },
  },
  methods: {
    cancelAction() {
      this.$router.push({
        name: "salePoint",
      });
      this.$pointOfSale.clearPointOfSaleForm();
    },
  },
  mounted() {
    this.$config.getBancos();
    this.$config.getEstados("9e1bf96ca2754ee6596f26fd6e6b5cc2");
    if (this.$pointOfSale.actionType == "new") {
      this.$pointOfSale.cadastro.dados_cadastrais.pessoa = "JURIDICA";
      this.$pointOfSale.cadastro.dados_bancarios.tipo_de_conta = "CORRENTE";
      this.$pointOfSale.cadastro.equipamentos.rede_vendas = "PRIVADA";
    }
    this.$loja_segmentos.getSegmentos();
    this.$loja_gerenciar.getRegionais();
    this.$pessoas_agentes.getAgentes();
    this.$tipos_pdv.getTiposPDV();
    this.$pointOfSale.getPointOfSaleStatus();
  },
  destroyed() {
    this.$pointOfSale.clearPointOfSaleForm();
  },
};
</script>

<style></style>
